import { useMemo } from "react";
import { DateFormatter, sortMonths } from "../utils";

const cleanCustomerName = (name) => {
    if (!name || typeof name !== 'string') return null;

    const suffixes = [
        "B.V.", "S. DE R.L. DE C.V.", "S.A. DE C.V.", "SA DE CV", "S.A. de C.V.",
        "S.A.B. de C.V.", "S. DE C.V.", "S.A.B.", "DE C.V.", "S DE R.L.", "S. DE R.L."
    ];

    //Erase the comma and the legal suffix if it's at the end of the string
    const suffixRegex = new RegExp(`(,\\s*)?(${suffixes.join('|')})$`, 'i');
    let cleaned = name.replace(suffixRegex, '').trim();

    //Apply Pascal Case in strings with 4 or more characters (This to avoid applying it to things like 3M, CMI, etc.)
    const formatted = cleaned
        .split(/\s+/)
        .map(word => {
        return word.length >= 4
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : word;
        })
        .join(' ');

    return formatted || null;
};

const formatForecast = (forecast) => {
    const dateString = forecast.replace("Forecast: on ", "").slice(0, -1);

    const parts = dateString.split(' ');
    let correctDate;

    //Apply the UTC format to the date before sending it to DateFormatter
    if (parts.length >= 4) {
        correctDate = `${parts[1]} ${parts[0]} ${parts[2]} ${parts[3]} UTC`
    } else {
        correctDate = dateString + ' UTC';
    }

    const dateObject = new Date(correctDate);

    if(isNaN(dateObject.getTime())) {
        console.error("Invalid Date created for forecast:", dateString);

        return "Error de formato de fecha";
    }

    return DateFormatter(dateObject, 'GENERATED');
}

//Derives the sidebar-ready forecast list (display name, formatted customers, formatted date) from the raw getAll() response
export const useForecastList = (forecasts) => {
    return useMemo(() => {
        if (forecasts.length === 0) {
            return [];
        }

        return forecasts.map(forecast => {
            const months = forecast.uniqueMonths || [];

            const sortedMonths = sortMonths(months);
            let dateRange = "Sin rango...";

            if (sortedMonths.length > 0) {
                dateRange = `${sortedMonths[0]} - ${sortedMonths[sortedMonths.length - 1]}`;
            }
            const displayName = forecast.name !== forecast.prefix.slice(0, -1) ? forecast.name : dateRange;

            const formattedCustomers = (forecast.uniqueCustomers || []).map(cleanCustomerName).filter(Boolean).join(', ');
            return {id: forecast, displayName: displayName, customers: formattedCustomers, date: formatForecast(forecast.prefix)}
        });
    }, [forecasts])
}